export const GOOGLE_MAPS_LIBRARIES = Object.freeze(["places"]);

export const googleMapsLoaderOptions = {
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDKX4TjlGMne-DIIucVFT6FRmTiMXKkcqs",
    libraries: GOOGLE_MAPS_LIBRARIES
};